const FontAwesomeIcon = ({ icon, size, color }) => {
    if (!icon) return null;
    return <i className={icon} style={{ fontSize: size, color: color }}></i>;
};

export default FontAwesomeIcon;
